import React from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import ProviderWithBootstrapper from "@components/Bootstrapper";

const HeaderFooterWrapper = ({ element }) => {
  const queryClient = new QueryClient();
  return (
    <ProviderWithBootstrapper>
      <QueryClientProvider client={queryClient}>
        {element}
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </ProviderWithBootstrapper>
  );
};

export default HeaderFooterWrapper;
